import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';

interface IDescriptionRowProps {
  label: string;
  text: string;
  action?(): void;
}

export const DescriptionRow = ({ label, text, action }: IDescriptionRowProps) => {
  return (
    <div className={styles['row']}>
      <div className={styles['about-title']}>
        <ArticleHeading4>{label}</ArticleHeading4>
      </div>
      <span className={styles['about-text']}>
        <ArticleParagraph1>
          {text}
          {action && (
            <span className={styles['maximize-button']} onClick={action}>
              {' '}
              Развернуть
            </span>
          )}
        </ArticleParagraph1>
      </span>
    </div>
  );
};
